import React, { createContext, useContext, useState } from 'react';
const OtpContext = createContext(undefined);
const OtpContextProvider = ({
  handleOtpSubmit,
  children
}) => {
  const [otpFormData, setOtpFormData] = useState({
    phoneNumber: null,
    email: '',
    countryCode: ''
  });
  const [otpDeliveryType, setOtpDeliveryType] = useState();
  const [showOtpVerificationForm, setShowOtpVerificationForm] = useState(false);
  const [verificationApiFunction, setVerificationApiFunction] = useState();
  const [resendInProgress, setResendInProgress] = useState(false);
  const [otpResent, setOtpResent] = useState(false);
  const [otpRequestErrorMsg, setOtpRequestErrorMsg] = useState('');
  const value = {
    otpRequestErrorMsg,
    setOtpRequestErrorMsg,
    otpResent,
    setOtpResent,
    resendInProgress,
    setResendInProgress,
    otpDeliveryType,
    setOtpDeliveryType,
    otpFormData,
    setOtpFormData,
    showOtpVerificationForm,
    setShowOtpVerificationForm,
    verificationApiFunction,
    setVerificationApiFunction,
    handleOtpSubmit
  };
  return React.createElement(OtpContext.Provider, {
    value: value
  }, children);
};
const useOtpContext = () => {
  const context = useContext(OtpContext);
  if (!context) {
    throw new Error('useOtpContext must be used within an OtpContextProvider');
  }
  return context;
};
export { OtpContextProvider, useOtpContext };